import React from 'react';
import MyButton from '../components/UI/MyButton/MyButton';
import { useNavigate } from 'react-router';
import { LOGIN_ROUTE } from '../utils/consts';

const NoAccess = () => {
    const navigate = useNavigate();

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '40vh',
                gap: 10,
            }}
        >
            <h1 style={{ color: 'red', fontSize: 80 }}>НЕТ ДОСТУПА</h1>
            <MyButton onClick={() => navigate(LOGIN_ROUTE)}>Перейти на страницу входа</MyButton>
        </div>
    );
};

export default NoAccess;

